import React, { FC, useState } from 'react';
import { useNavigate } from 'react-router';
import { useSelector } from 'react-redux';
import useLocales from 'hooks/useLocales';
import Navbar from 'components/Navbar';
import Image from 'components/image/Image';
import Footer from 'components/Footer/Index';
import Popup from 'components/shared/Popups/Popup/Index';
import UpgradePlanPopup from 'components/shared/Popups/UpgradePlan/Index';
import RecruitMembership from 'components/RecruitMembership/Index';
import OrderHistory from 'components/OrderHistory/Index';
import { PageType } from 'core/enum/page';
import { IMe } from 'core/interface/me';

import './Index.scss';

const Membership: FC = (): JSX.Element => {
  const navigate = useNavigate();
  const { t } = useLocales();
  const me = useSelector((state: IMe) => state.user).user;
  const [pageType, setPageType] = useState<PageType>(
    PageType.RECRUIT_MEMBERSHIP
  );
  const [isPlanModalOpen, setIsPlanModalOpne] = useState<boolean>(false);

  const changePageType = (type: PageType) => {
    setPageType(type);
  };

  return (
    <div
      className="membership"
      style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}
    >
      <Navbar />
      <div className="membership" style={{  paddingLeft: '40px', paddingRight: '40px' }}>
        <div className="navigation_section">
          <div
            className="back_button skillio-back-button"
            onClick={() =>
              navigate(
                me?.role == 'admin' ? '/company/find-candidates' : '/dashboard'
              )
            }
          >
            <Image name="arrow-left.svg" />
            {t('Back')}
          </div>
          <div className="membership_navigate">
            <div
              className="membership_item"
              onClick={() => changePageType(PageType.RECRUIT_MEMBERSHIP)}
            >
              <Image name="member.svg" />
              {t('My membership')}
            </div>
            <div
              className="membership_item"
              onClick={() => changePageType(PageType.ORDER_HISTORY)}
            >
              <Image name="document.svg" />
              {t('Order history')}
            </div>
          </div>
        </div>
        <div className="main_section" style={{ flex: 1 }}>
          {pageType === PageType.RECRUIT_MEMBERSHIP ? (
            <RecruitMembership />
          ) : (
            <OrderHistory />
          )}
        </div>
      </div>
      {isPlanModalOpen && (
        <Popup
          title={t('Upgrade your plan')}
          description={t('Your subscription plan determines how many profiles you can unlock, how many new jobs you can post and how many AI credits you can use each month. Once you use up these credits, they won’t be replenished - even if you delete a job post. Any unused credits at the end of your billing cycle will roll over to the next month, so you don’t lose them.')}
          onClose={() => setIsPlanModalOpne(false)}
          className="plan-modal"
        >
          <UpgradePlanPopup t={t} />
        </Popup>
      )}
      <Footer />
    </div>
  );
};

export default Membership;
